export default {
  path: '/auth',
  name: 'auth',
  redirect: { name: 'login' },
  component: () => import(/* webpackChunkName: "layout.auth" */ '../views/layouts/auth.vue'),
  children: [
    {
      path: 'login',
      name: 'login',
      meta: {
        title: 'Acessar Conta',
        auth: false,
        RedirectIfAuthenticated: true
      },
      component: () => import(/* webpackChunkName: "auth.login" */ '../views/auth/Login.vue')
    },
    {
      path: 'criar-conta',
      name: 'signup',
      meta: {
        title: 'Cria uma nova conta',
        auth: false,
        RedirectIfAuthenticated: true
      },
      component: () => import(/* webpackChunkName: "auth.signup" */ '../views/auth/Register.vue')
    },
    {
      path: 'recuperar-senha',
      meta: {
        title: 'Recuperar senha',
        auth: false,
        RedirectIfAuthenticated: true
      },
      component: () => import(/* webpackChunkName: "auth.recover" */ '../views/auth/Recover.vue')
    },
    {
      path: 'nova-senha/:token/:email',
      meta: {
        title: 'Criar nova senha',
        auth: false,
        RedirectIfAuthenticated: true
      },
      component: () => import(/* webpackChunkName: "auth.newpassword" */ '../views/auth/NewPassword.vue')
    },
    {
      path: 'nova-senha/:token/:email',
      meta: {
        title: 'Criar nova senha',
        auth: false,
        RedirectIfAuthenticated: true
      },
      component: () => import(/* webpackChunkName: "auth.newpassword" */ '../views/auth/NewPassword.vue')
    },
    {
      path: 'email/verify/:id/:hash',
      meta: {
        title: 'Confirmação de E-mail',
        auth: false,
        RedirectIfAuthenticated: false
      },
      component: () => import(/* webpackChunkName: "auth.newpassword" */ '../views/auth/Confirmation.vue')
    }
  ]
}
